import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopy from '@mui/icons-material/ContentCopy'
import TextField from '@mui/material/TextField'
import { Grid } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

class TransactionLine extends React.Component {
    state = {
        edit_date:false,
        edit_comment:false,
        edit_sum:false,
        dateValue:dayjs(Date.now()),
        editing:false,
        dateString:"",
    }
    constructor(props) {
        super(props);
        this.handleClick = this.clickSum.bind(this);
        this.correctSum = this.correctSum.bind(this);
    };

    clickSum(e) {
        if(e.detail ==2) {
            console.log("Clicked");
            // this.props.info.setSum(this.props.info.sum + 1);
            this.setState({edit_sum: true})
            this.forceUpdate();
        }
    }

    correctSum(e) {
        console.log(e.target.value);
        const num = parseInt(e.target.value);
        if(num) {
            this.props.info.setSum(num);
            this.forceUpdate();
        }
    }


    render() {
        var date_field, comment_field, sum_field
        if(this.state.editing)
        { 
            date_field =  
                <TextField 
                    value = {this.state.dateString}
                    onChange={(e) => this.setState({dateString:e.target.value})}
                    onBlur={(e) => {
                        console.log("on blur, e=", e)
                        var date = dayjs(new Date(this.state.dateString))
                        console.log("date=", date)
                        this.props.info.setDate(date)
                        this.props.updateHandle()    
                    }
                    }
                    />
            comment_field = <TextField
                fullWidth
                value = {this.props.info.comment}
                onChange={(e) => {this.props.info.setComment(e.target.value); this.forceUpdate()}}
                />;
                sum_field = <TextField
                    fullWidth
                    value = {this.props.info.sum}
                    onChange={(e) => {this.props.info.setSum(e.target.value); this.forceUpdate()}}
                    onBlur={() => this.props.updateHandle()}
                />;
        }
        else {
            comment_field = <ListItemText>{this.props.info.comment}</ListItemText>
            sum_field = <ListItemText style={{fontWeight:'bold', color:this.props.info.sum<0 ? "red" : "green"}}>
                {this.props.info.sum}
                </ListItemText>
            date_field =  <ListItemText>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                {this.props.info.date.toString().substr(4, 12)}
                </LocalizationProvider>
            </ListItemText>
        }

        var trList = 
        <ListItem 
            onDoubleClick={() => {this.setState({
                editing:true,
                dateString: this.props.info.date.toString().substr(4, 12)
            })}}
            onBlur={() => this.setState({editing:false})}
            onContextMenu={(event) => {
                event.preventDefault()
                this.props.contextHandler(event, this.props.index)
            }}
        >
            <Grid container spacing={2}>
                <Grid item xs={1}></Grid>
                <Grid item xs={2}>{date_field}</Grid>
                <Grid item xs={5}>{comment_field}</Grid>
                <Grid item xs={2}>{sum_field}</Grid>
                {/* <Grid item xs={1}><ContentCopy onClick={() => this.props.copyHandle(this.props.index)}/></Grid> */}
                <Grid item xs={1}><DeleteIcon onClick={() => this.props.deleteHandle(this.props.index)}/></Grid>
            </Grid>
        </ListItem>;

        return(
            <div>
                {trList}
            </div>)
    }
    
}


export default TransactionLine;
